import { useTranslation } from 'react-i18next';
import style from './style.module.css';


export const HeaderSide = () => {
    const {t} = useTranslation();
  return (
    <div className={style.container}>
    <div className={style.content}>
    <div className={style.title}>
      <div className={style.title_header}>
                  <h1>Тепловая карта по видам животных</h1>
                  {/* <Button style={{marginLeft: '5px'}} type="primary" icon={<img src="../report.svg" alt="Plus Icon" style={{ width: '16px', height: '16px' }} />} onClick={ () => setShowReportModal(true) }>
      { t('general.generate_report') }
    </Button> */}
  </div>
                  <div className={style.title_inner}>
                      <img src="./homeicon.svg" alt="home" />
                      <p>{t('Home')}</p>
                      <img src="./arrowright.svg" alt="arrow" />
                      <p>Валовый сбор продукции</p>
                      <img src="./arrowright.svg" alt="arrow" />
                      <span className={style.namepage}>Тепловая карта по видам животных</span>
                  </div>


              </div>
        
      <div style={{ position: 'relative' }}>
        
    </div>
  </div>
  </div>
  );
};          